import { List } from '@mui/material';
import type { ReactNode } from 'react';

export const MENU_WIDTH = '240px';

export const NavList = (props: { children: ReactNode }) => (
    <List sx={{ width: MENU_WIDTH }}>{props.children}</List>
);
